import React, { useState } from "react";

import cx from "classnames";
import styles from "./InsurerLogo.module.scss";
import AboutInsurerModal from "../Modals/AboutInsurerModal/AboutInsurerModal";
// import logoStyles from "../../../../../sass/objects/logo";

type InsurerLogoProps = {
    className?: string;
    providerId: number;
    includesAboutInsurerModal?: boolean;
};

interface IGetProviderNameByProviderId {
    [providerId: number]: string;
}

const getProviderNameByProviderId: IGetProviderNameByProviderId = {
    2: "aia",
    3: "fidelity",
    4: "asteron",
    5: "nib",
    6: "partnerslife",
    9: "chubblife",
    10: "southerncross",
    11: "accuro"
};

const InsurerLogo: React.FC<InsurerLogoProps> = (props) => {
    const { className, providerId, includesAboutInsurerModal } = props;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const providerName = getProviderNameByProviderId[providerId];

    if (!providerName) {
        return null;
    }

    return (
        <React.Fragment>
            <AboutInsurerModal
                providerId={providerId}
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            />
            <div
                className={cx([
                    styles[providerName],
                    styles["insurer-logo"],
                    {
                        [className]: !!className,
                        [styles["insurer-logo--hovered"]]: includesAboutInsurerModal
                    }
                ])}
                onClick={() => (includesAboutInsurerModal ? setIsModalOpen(true) : null)}>
                <div
                    className={cx({
                        [styles["insurerlogo"]]: true // Existing
                    })}
                />
            </div>
        </React.Fragment>
    );
};

export default InsurerLogo;
